<template>
  <div id="app" :style="{marginTop:marginTop}">
 
    <app-header v-show="isShowHeader" :Pagetitle='title' />
    <!-- 消息通知 -->
    <van-notice-bar left-icon="volume-o" color="#444" background="#ffdcdc" :mode="message.link_m ? 'link' : 'closeable'" v-if="message.content" @click="onClickMessage(message.link_m)">{{ message.content }}</van-notice-bar>
    <!-- 缓存界面选择加载 -->
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"  />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    
  </div>
</template>
<script>
import Header from './components/Header'
const WAY = process.env.WAY;
export default {
  name: 'App',
   data() {
        return {
            title: '',
            isShowHeader: true,
            path:'',
            marginTop:'46px',
            message: {},
        }
    },
    watch: {
        $route(to, from) {
            // console.log('to', to, 'from', from)
            this.path = to.name ? (to.name).toLowerCase() : 'home';
            // this.isShowHeader = this.path == 'home' ? false : true;
            this.marginTop = this.isShowHeader ? '46px' : '0px';
            this.message = this.$storage.get('message', {});
            if (this.message.content) {
                this.$storage.remove('message');
            }

            // if (WAY != 'android') {
            //     // matomo
            //     // let uid = this.$storage.get("uid", '0');
            //     let username = this.$storage.get("username", '0');
            //     window._paq.push(['setUserId', username]); // To track a page view
            //     window._paq.push(['setCustomVariable', 1, 'username', username, 'visit']); // To track a page view
            // }
        },
    },
    components: {
        'app-header':Header,
    },
    created() {
        if (this.path == '') { //首次进入
            let current = this.$router.currentRoute
            let currentName = current.name ?  (current.name).toLowerCase() : 'home'
            // this.isShowHeader = currentName == 'home' ? false : true
            this.marginTop = this.isShowHeader ? '46px' : '0px'
        }
    },

    mounted() {
         setTimeout(() => {
            let referrer = document.referrer;
            let access_url = this.$route.path;
            let user_agent = navigator.userAgent;
            let ip =  typeof returnCitySN != 'undefined' && returnCitySN.cip;
            if (referrer) {
                this.$http
                    .post("access_origin_log", { referrer, access_url, user_agent, ip, site: this._getGlobal('site') })
                    .then((res) => {
                        console.log('access_origin_log res', res)
                    })
                    .catch((err) => {
                        console.log("access_origin_log err", err);
                    });
            }
        }, 500); 
    },
      methods: {
        onChangeTitle(title = "") {
            this.title = title;
        },
        onClickMessage(path) {
            this.message = {};
            if (path) {
                if (path.s) {
                    this.$router.push({
                        name: path.s,
                        params: path.p,
                    })
                }else {
                    this._goPath(path)
                }
            }
        },
        onChangeMessage(info) {
            this.message = info;
        }
    },
}

</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: 0px;
  margin-right: 0px;
  /*padding-bottom: 3.5rem;*/
  color: #2c3e50;
  margin-top: 46px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue